import { cn } from '@/utils/cn';

type Props = {
  className?: string;
  center?: boolean;
};

const Loading = ({ className = '', center = false }: Props) => {
  return (
    <div className={cn('flex h-screen justify-center', center ? 'items-center' : '', className)}>
      <div className="h-12 w-12 animate-spin rounded-full border-t-2 border-amber-500"></div>
    </div>
  );
};

export default Loading;
